import { map } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios, exportRequest } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
    type: 'prepayment',
    source: 'web',
  },
  record: null,
};

const slice = createSlice({
  name: 'invoicePrepayment',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET INVOICES
    getInvoicesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // GET INVOICE
    getInvoiceSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },

    // CREATE INVOICE
    createInvoiceSuccess(state, action) {
      const record = action.payload;
      state.isLoading = false;
      state.data = [...state.data, record];
      state.error = false;
    },

    // UPDATE INVOICE
    updateInvoiceSuccess(state, action) {
      state.record = action.payload;
      const updateRecord = map(state.data, (_record) => {
        if (_record.id === state.record.id) {
          return state.record;
        }
        return _record;
      });

      state.isLoading = false;
      state.data = updateRecord;
      state.params = { ...state.params };
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams } = slice.actions;

// ----------------------------------------------------------------------

export function getInvoices(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/invoice/', {
        params,
      });
      dispatch(slice.actions.getInvoicesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getInvoice(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/invoice/${id}/`);
      dispatch(slice.actions.getInvoiceSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createPrepayment(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/invoice/create-prepayment/', record);
      dispatch(slice.actions.createInvoiceSuccess(response.data));
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function actionInvoice(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/invoice/${id}/action/`, data);
      dispatch(slice.actions.updateInvoiceSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function actionHistoryInvoice(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/invoice/${id}/history/`, data);
      dispatch(slice.actions.updateInvoiceSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function sendInvoice(id, params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/invoice/${id}/send/`, { params });
      dispatch(slice.actions.updateInvoiceSuccess(response.data));
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function exportInvoices(params = {}) {
  return async () => {
    exportRequest('/invoice/export/', params, 'invoice.Invoice');
  };
}

// ----------------------------------------------------------------------

export function getAvailablePrepayments(partnerId) {
  return async () => {
    const response = await axios.get('/invoice/available-prepayments/', { params: { partner: partnerId } });
    return response.data;
  };
}
